import ReactSpeedometer from 'react-d3-speedometer';

const Speedometer = ({ needleValue }) => {
  return (
    <ReactSpeedometer
      segments={3}
      segmentColors={['#dc3545', '#ffc107', '#198754']}
      maxSegmentLabels={0}
      height={200}
      minValue={0}
      maxValue={150}
      value={needleValue}
      needleColor="#212529"
      valueTextFontSize="0px"
      ringWidth={35}
    />
  );
};

export default Speedometer;
